import { ImageUploadImageSetModel } from './../../image-admin/image-models/image-upload-image-set.model';
import { Component, ElementRef, EventEmitter, Input, OnInit, OnChanges, Output } from '@angular/core';
import {ProductModel} from '../models/product.model';
import { ModelModel } from '../models/model.model';
import {ProdcutImageUtil} from '../../lib/product-image-util';

@Component({
  selector: 'app-model-details-carousel',
  template: `
  <div class="container">
    <div class="row">
      <!-- Controls -->
      <div class="d-none d-lg-block col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 indcontrol" style="align-items: center;">
        <a class="left carousel-control-prev" href="#carousel-custom" data-slide='prev' style="display: block; margin-right: 0; margin-left: auto;">
          <i class="fa fa-chevron-left" style="color: #A50034; font-size: 38px"></i>
          <span class="sr-only">Previous</span>
        </a>
      </div>

      <div id="carousel-custom" class="carousel slide col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-10" data-ride="carousel">
        <div class='carousel-outer'>
          <!-- Wrapper for slides -->
          <div class="carousel-inner" role="listbox">
            <div *ngFor="let image of this.imageSetsToUse; let first = first;" [ngClass]="first ? 'item carousel-item active' : 'item carousel-item'">
             <picture class="product-img-elem">
                <source srcset={{image.highresimage.url}} media="(min-width: 1920px)" />
                <source srcset={{image.desktoplargeimage.url}} media="(max-width: 1919px) and (min-width: 1280x)" />
                <source srcset={{image.desktopsmallimage.url}} media="(max-width: 1279px) and (min-width: 1024px)" />
                <source srcset={{image.tabletimage.url}} media="(max-width: 1023px) and (min-width: 769px)" />
                <img src={{image.phoneimage.url}} alt="" />
              </picture>
            </div>     
          </div>
        </div>

        <!-- Indicators -->
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 indcontainer" style="height:100px">
          <ol class="carousel-indicators">
            <li *ngFor="let image of this.imageSetsToUse; let first = first; let i = index" data-target="#carousel-custom" [attr.data-slide-to]="i" [ngClass]="{'active': first}">
              <div class="d-none d-lg-block indicatorDiv">
                <picture class="product-img-elem">
                  <source srcset={{image.highresimage.url}} media="(min-width: 1920px)" />
                  <source srcset={{image.desktoplargeimage.url}} media="(max-width: 1919px) and (min-width: 1280x)" />
                  <source srcset={{image.desktopsmallimage.url}} media="(max-width: 1279px) and (min-width: 1024px)" />
                  <source srcset={{image.tabletimage.url}} media="(max-width: 1023px) and (min-width: 769px)" />
                  <img src={{image.phoneimage.url}} alt="" />
                </picture>
              </div>
            </li>
          </ol>
        </div>
        </div> 

      <div class="d-none d-lg-block col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 indcontrol" style="align-items: center;">
        <a class="right carousel-control-next" href="#carousel-custom" data-slide='next' style="display: block; margin-right: auto; margin-left: 0;">
          <i class="fa fa-chevron-right" style="color: #A50034; font-size: 38px"></i>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  `,
  styles: [
    `
    #carousel-custom {
      margin-top:  10px;
      width: 100%;
    }

    @media only screen and (max-width : 769px){
      .carousel-indicators li{
          width: 10px;
          height: 10px;
          border: 1px solid #A50034;
          border-radius:5px;
      }

      .carousel-indicators li.active {
          width: 10px;
          height: 10px;
          background-color:#A50034;
      }

      .indcontainer {
        height: 50px !important;
      }

      .displayImage {
        height: 200px;
      }
    }

    @media only screen and (min-width : 1024px){
     .col-lg-10 {
      flex: 0 0 80.333333% !important;
     }

    }

    @media only screen and (min-width : 769px){
      .indcontrol{
        display: flex !important;
      }

      .indicatorDiv {
        display: flex !important;
      }

      .carousel-indicators {
        display: flex;
        position: relative;
        margin-top: 20px;
        margin-left: 0% !important;
        justify-content: flex-start;
      }

      .carousel-indicators li {
        margin-right: 100px !important;
      }

    }

    .carousel-inner {
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5) !important;
    }

    .carousel-indicators li {
      text-indent: 0px !important;
    }

    .indicatorDiv {
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5) !important;
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      padding: 2px;
    }

    .indicatorDiv img{
      max-width: 100%;
      max-height: 100%;
    }

    .carousel-indicators li.active div {
      border: 2px solid #A50034 !important;
    }

    .carousel-indicators li.active .indicatortext {
      border: 0px !important;
      text-align: center;
      width: 100px;
      color: #A50034;
      display: flex;
      align-items: center;
      padding: 2px;
      font-size: 14px;
    }

    .carousel-indicators li .indicatortext {
      border: 0px !important;
      text-align: center;
      width: 100px;
      color: #4A4A4A;
      display: flex;
      align-items: center;
      padding: 2px;
      font-size: 14px;
    }

    #carousel-custom .carousel-outer {
        position: relative;
    }
    .carousel-control-prev.left {
        background-image: none;
        width: 54px;
        height: 54px;
        top: 25%;
        border: 2px solid #fff;
        opacity: 1;
        text-shadow: none;
        -webkit-transition: all 0.2s ease-in-out 0s;
        -o-transition: all 0.2s ease-in-out 0s;
        transition: all 0.2s ease-in-out 0s;
    }
    .carousel-control-next.right {
        background-image: none;
        width: 54px;
        height: 54px;
        top: 25%;
        border: 2px solid #fff;
        opacity: 1;
        text-shadow: none;
        -webkit-transition: all 0.2s ease-in-out 0s;
        -o-transition: all 0.2s ease-in-out 0s;
        transition: all 0.2s ease-in-out 0s;
    }

    .displayImage {
      display: block;
      margin-left: auto;
      margin-right: auto;
      max-width: 100%;
      height: 280px;
    }

    .product-img-elem {
      margin: auto;
      display: block;
      max-height: 280px;
      text-align: center;
    }
  `
  ]
})
export class ModelDetailsCarouselComponent implements OnChanges {
  @Input() model: ModelModel;
  @Input() iscommercial: string;
  @Input() class: string;
  imageUtil = new ProdcutImageUtil();
  imageSetsToUse: ImageUploadImageSetModel[];
  ngOnChanges() {
    this.imageSetsToUse = this.imageUtil.getImagesSets(
      this.imageUtil.translateClassName(this.iscommercial, this.class),
      this.iscommercial,
      this.model.images);
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/components/model-details-carousel.component.ts